/* eslint-disable prefer-destructuring */

export const IS_SANDBOX = process.env.IS_SANDBOX;
export const IS_BETA = process.env.IS_BETA;
